<template>
  <div>
    <ModalPost :post-id="postId" />
    <ModalChannel :channel-id="channelId" />
    <ModalFeed
      :feed-id="feedId"
      :feed-rule-id="feedRuleId"
    />
    <ModalJob
      :job-id="jobId"
      :job-item-id="jobItemId"
    />
    <ModalList
      :list-id="listId"
      :list-item-id="listItemId"
    />
    <ModalWikipedia
      :wikipedia-page-id="wikipediaPageId"
      :wikipedia-table-id="wikipediaTableId"
    />
    <ModalTag :tag-id="tagId" />
    <ModalCommonString :common-string-id="commonStringId" />
    <ModalNetwork :network-id="networkId" />
    <ModalProfile :profile-id="profileId" />

    <ModalLogs />
  </div>
</template>

<script>
export default {
  components: {
    ModalLogs: () => import('@/components/admin/fetcher/modals/Logs'),

    ModalPost: () => import('@/components/admin/fetcher/modals/Post'),
    ModalChannel: () => import('@/components/admin/fetcher/modals/Channel'),
    ModalFeed: () => import('@/components/admin/fetcher/modals/Feed'),
    ModalJob: () => import('@/components/admin/fetcher/modals/Job'),
    ModalList: () => import('@/components/admin/fetcher/modals/List'),
    ModalWikipedia: () => import('@/components/admin/fetcher/modals/Wikipedia'),
    ModalTag: () => import('@/components/admin/fetcher/modals/Tag'),
    ModalCommonString: () => import('@/components/admin/fetcher/modals/CommonString'),
    ModalNetwork: () => import('@/components/admin/fetcher/modals/Network'),
    ModalProfile: () => import('@/components/admin/fetcher/modals/Profile'),
  },

  data() {
    return {
      group: 'fetcher',

      postId: null,
      channelId: null,
      feedId: null,
      feedRuleId: null,
      jobId: null,
      jobItemId: null,
      listId: null,
      listItemId: null,
      wikipediaPageId: null,
      wikipediaTableId: null,
      tagId: null,
      commonStringId: null,
      networkId: null,
      profileId: null,
    };
  },

  created() {
    this.setupEventListeners();
  },

  beforeDestroy() {
    Bus.$off('toggle_modal');
    Bus.$off('set_modal_model_id');
    Bus.$off('inspect_post');
  },

  methods: {
    setupEventListeners() {
      Bus.$on('inspect_post', (pid) => {
        Bus.$emit('toggle_modal', 'post', pid);
      });

      Bus.$on('toggle_modal_with_model', (group, modal, modelId) => {
        if (group === this.group) {
          // console.log('modals.toggle_modal', modal, modelId);
          Bus.$emit(group, 'set_modal_model_id', modal, modelId);
          Bus.$emit('toggle_modal', modal);
        }
      });

      Bus.$on('set_modal_model_id', (group, modal, modelId) => {
        if (group === this.group) {
          // console.log(`setting ${modal}Id to ${modelId}`);
          this[`${modal}Id`] = modelId;
        }
      });
    },
  },
};
</script>
